import { render, staticRenderFns } from "./edit-acct.vue?vue&type=template&id=c4ebce14&scoped=true&"
import script from "./edit-acct.vue?vue&type=script&lang=ts&"
export * from "./edit-acct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ebce14",
  null
  
)

export default component.exports